// import firebase from 'firebase/compat/app';
import { initializeApp,getApps,getApp as getapp} from "firebase/app"
import { getFirestore,initializeFirestore,memoryLocalCache,enableIndexedDbPersistence,connectFirestoreEmulator } from "firebase/firestore";
import { getDatabase,ref,onValue,get,query,orderByChild, equalTo } from "firebase/database";
import { getAuth,setPersistence,browserSessionPersistence } from "firebase/auth";
export default class FirebaseConfig {
  firebaseCredentials() {
    let database = "https://pargolfsolutions-e4659-default-rtdb.firebaseio.com"
    if(process.env.VUE_APP_FIREBASE_ENV == "development"){
    database = "http://54.215.97.142:50042?ns=pargolfsolutions-e4659-default-rtdb"
    }
    return {
    apiKey: "AIzaSyDxhE476jZUhIcJIAiWLDAhUuvHQ8NxGiY",
    authDomain: "pargolfsolutions-e4659.firebaseapp.com",
    projectId: "pargolfsolutions-e4659",
    databaseURL: database,
    storageBucket: "pargolfsolutions-e4659.appspot.com",
    messagingSenderId: "676981839003",
    appId: "1:676981839003:web:12a849e36faec2c6dba23e",
    measurementId: "G-EC74PYSX3L"}
  }

  async firebaseInitMainApp() {
    if (!getApps().length) {

      initializeApp(this.firebaseCredentials());
      // firebase.firestore().settings(App.FirestoreCONF);
      if(process.env.VUE_APP_FIREBASE_ENV != "development"){
        //enableIndexedDbPersistence(getFirestore(),{forceOwnership:true})
        //await getFirestore().enablePersistence({synchronizeTabs:true});
        //await getAuth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        setPersistence(getAuth(), browserSessionPersistence)
      }
    }
  }
  getSubdomain(url){
    let domain = url;
    if (url.includes("://")) {
        domain = url.split('://')[1];
    }
    const subdomain = domain.split('.')[0];
    return subdomain;
  }

  async getTenantBySubdomain(subdomain){
      try{
      let subdomainDb = subdomain
      console.log(subdomainDb)
      await this.firebaseInitMainApp()
      let mainApp = await this.getApp()
      const dbFireConfig = getDatabase(mainApp)
      let dataValue = ref(dbFireConfig, `/`)
      let val = await get(query(dataValue,orderByChild("Subdominio"),equalTo(subdomainDb)))
      if(val.exists()){
        const dataTenant = val.val()
        const data = Object.entries(dataTenant)
        return data[0][0]
      }else{
        return false
      }
      }catch(e){
        console.log(e)
        return false
      }
      
    }

  async getUrlDatabaseByTenant(tenant){
    let mainApp = await this.getApp()
    const dbFireConfig   =  getDatabase(mainApp);
    let dataValue = ref(dbFireConfig,`${tenant}/databaseURL`);
    let val = await get(
      query(dataValue)
    );
    if(val.exists()){
      return {ok:true,urlDatabase:val.val(),tenant:tenant}
    }else{
      return {ok:false};
    }
  }

  async getUserTenantByUserType(tenant,userType){
    let mainApp = await this.getApp()
    const dbFireConfig   = getDatabase(mainApp);
    let data = ref(dbFireConfig,`${tenant}/AuthTenants/${userType}`);
    let dataValue = await get(
      query(data)
    );
    if(dataValue.exists()){
      return {ok:true,userTenant:dataValue.val()}
    }else{
      return {ok:false};
    }
  }

  async getUserTenantConfig(tenant,userType){
    let mainApp = await this.getApp()
    const dbFireConfig   = getDatabase(mainApp);
    let data = ref(dbFireConfig,`${tenant}`);
    let dataValue = await get(
      query(data)
    );
    if(dataValue.exists()){
      return {ok:true,conf:dataValue.val()}
    }else{
      return {ok:false};
    }
  }

  

  setPersistence(App){
    try{
      initializeFirestore(App, {
        localCache: memoryLocalCache(),
      });
      return true;
    }catch(e){
      return false;
    }
  }

  async getApp(tenant,urlDatabase,credentialParam){
      try{
        return getapp(tenant);
      }catch(e){
        if(this.isFirebaseError(e,"app/no-app")){
            if (tenant) {
              try{
                let tenantInfo = await this.getUrlDatabaseByTenant(tenant);
                const App = initializeApp({
                  ...getapp().options,
                  databaseURL: tenantInfo.urlDatabase
                },tenant)
                /*if(process.env.VUE_APP_FIREBASE_ENV != "development"){
                let persistence = this.setPersistence(App);
                }*/
                return App ;
              }catch(e){
                if(this.isFirebaseError(e,"app/duplicate-app")){
                  return getapp(tenant);
                }
              }
            }
        }
      }
  }


  isFirebaseError(err,err_code){

      if (typeof err.code === "string" ) {
        if (!err_code || err.code === err_code) {
          return true;
        }
      }
    return false;
  }


  setTenantInLocal(Tenant){
    localStorage.setItem('ParGolfTenant',Tenant );
  }

  getTenantInLocal(){
    return localStorage.getItem('ParGolfTenant')
  }

}







